import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api, { formatDkk } from '@/lib/api';
import { trackEvent } from '@/lib/analytics';

export default function ProviderReferrals() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);
  const [skip, setSkip] = useState(0);
  useEffect(() => {
    let active = true;
    setError('');
    api.get('/experts/me/referrals', { params: { skip } }).then(r => { if (active) setData(r.data); })
      .catch(() => { if (active) setError('Invitationerne kunne ikke hentes. Prøv at genindlæse siden.'); });
    return () => { active = false; };
  }, [skip]);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(data.link);
      setCopied(true);
      trackEvent('provider_referral_link_copied', { metadata: { placement: 'provider_dashboard' } });
    } catch { setError('Linket kunne ikke kopieres. Markér og kopiér det fra feltet.'); }
  };
  return <section className="my-6 rounded-2xl border border-brand-line bg-white p-5 sm:p-6" aria-labelledby="referral-heading">
    <h2 id="referral-heading" className="text-xl font-semibold text-brand-green">Invitér en person – tjen 500 kr. gebyrfrit</h2>
    <p className="mt-3 max-w-2xl text-sm leading-6">Når en person, du inviterer, bliver godkendt og gennemfører sin første betalte opgave, kan du tjene dine næste 500 kr. uden SpørgMigs normale platformgebyr.</p>
    <p className="mt-2 text-sm text-brand-body">Belønningen er gebyrfri indtjening og kan ikke udbetales som kontanter. Den optjenes efter frigivelsesperioden.</p>
    {error && <p role="alert" className="mt-3 text-sm text-red-700">{error}</p>}
    {!data && !error && <p className="mt-3" role="status">Henter invitationer…</p>}
    {data && <>
      <div className="mt-4 flex flex-wrap items-center gap-3"><button type="button" onClick={copy} className="btn-primary">{copied ? 'Link kopieret' : 'Kopiér invitationslink'}</button><span role="status" className="text-sm">Du har <strong>{formatDkk((data.wallet.balance_ore || 0) / 100)}</strong> gebyrfri indtjening tilbage.</span></div>
      <input aria-label="Dit invitationslink" readOnly value={data.link} onFocus={e => e.target.select()} className="mt-3 w-full min-w-0 rounded-lg border p-2 text-sm" />
      {data.wallet.recovery_fee_ore > 0 && <p className="mt-3 text-sm">Din belønning er sat på pause. Kontakt support for at få afklaret en tilbageført belønning.</p>}
      <ul className="mt-4 divide-y">{data.referrals.map(ref => <li key={ref.referred_id} className="py-3 text-sm">
        <strong>{ref.referred_name}</strong><div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-brand-body">
          <span>Inviteret ✓</span><span>Godkendt {ref.approval_status === 'approved' ? '✓' : 'Afventer'}</span>
          <span>Første opgave gennemført {ref.qualified_at ? '✓' : 'Afventer'}</span>
          <span>{ref.reward_status === 'earned' ? 'Belønning optjent ✓' : ref.reward_status === 'revoked' ? 'Belønning tilbageført' : 'Belønning afventer'}</span>
        </div>
      </li>)}</ul>
      {!data.total && <p className="mt-4 text-sm text-brand-body">Når en person opretter sig via dit link vises invitationen her.</p>}
      {data.total > 50 && <div className="mt-3 flex gap-4"><button disabled={!skip} onClick={() => setSkip(Math.max(0, skip-50))}>Forrige</button><button disabled={skip+50 >= data.total} onClick={() => setSkip(skip+50)}>Næste</button></div>}
    </>}
    <Link to="/regler-for-opgaver-og-betaling#invitationer" className="mt-4 inline-block text-sm text-brand-green underline">Læs reglerne for invitationer</Link>
  </section>;
}

